import { render, staticRenderFns } from "./businessKeyWord.vue?vue&type=template&id=0604cfe5&scoped=true"
import script from "./businessKeyWord.vue?vue&type=script&lang=js"
export * from "./businessKeyWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0604cfe5",
  null
  
)

export default component.exports